import { getBenefits, getInsuranceExtraInfoText } from "~/helpers/hardware-and-insurance/insuranceActionsHelper";
import { InsuranceCategories } from "~/components/insurance/GizmoPostPurchaseTerminalInsurance/types/insuranceCategories";

export const mapInsuranceProducts = ({ products, benefits }) => {
	const mappedProducts = products.map((insuranceProduct) => {
		return mapInsuranceProduct({ insuranceProduct, benefits });
	});

	return mappedProducts.sort((a, b) => {
		return a.sortOrder - b.sortOrder;
	});
};

export const mapInsuranceProduct = ({ insuranceProduct, benefits }) => {
	const gizmoInfo = getBenefits({
		benefits: benefits,
		isDownPayment:
			insuranceProduct?.paymentTypes?.includes("DOWN_PAYMENT") ||
			insuranceProduct?.categories?.includes(InsuranceCategories.FLEXIBLE_INSTALLMENTS_INSURANCES), // used to determine isDownPayment from products returned from /hardware-subscriptions/v1/insurance-subscriptions/{imei}/orderable-products
		isScreen: insuranceProduct.publicName?.includes("Skjermforsikring"),
	});

	const selectedInfoText = getInsuranceExtraInfoText({
		selectedInfoText: gizmoInfo?.selectedInsuranceInfoText,
		poid: insuranceProduct?.productId,
	});

	const isWatch = insuranceProduct.hardwareTypes?.includes("SMART_WATCH");
	const badge = isWatch && gizmoInfo?.watchBadge?.text ? gizmoInfo?.watchBadge : gizmoInfo?.badge;
	return {
		...insuranceProduct,
		badge,
		benefit: gizmoInfo?.benefits,
		preSelected: gizmoInfo?.preSelected,
		selectedInfoText,
	};
};
